import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Outlet, useNavigate } from "react-router-dom"

const DashboardLayout = () => {
  const navigate = useNavigate()
  const userState = useSelector((state) => state.user)

  useEffect(() => {
    if (!userState.user) navigate("/login")
  }, [])

  return (
    userState.user
      ? <Outlet />
      : null
  )
}

export default DashboardLayout
